<template>
	<view class="specifications">
		<view class="product">
			<image :src="attrSelect?.image" mode="aspectFill" class="img"></image>
			<view class="price-close">
				<view class="price-box">
					<text class="text">{{marketingType == '2' ? '拼团价' : userInfo.qrcodeSource == 1 && userInfo.vipGrade != 0 || attrSelect?.type == 11 || attrSelect?.type == 12 ? '会员价' : '零售价'}}</text>
					<text class="text f36">¥ </text>
					<text class="text f64">{{marketingType == '2' ? attrSelect?.groupPrice?.toFixed(2) : userInfo.qrcodeSource == 1 && userInfo.vipGrade != 0 || attrSelect?.type == 11 || attrSelect?.type == 12 ? attrSelect?.price?.toFixed(2) : attrSelect?.otPrice?.toFixed(2)}}</text>
				</view>
				<text class="old-price" v-if="userInfo.qrcodeSource == 1 && attrSelect?.type != 11 && attrSelect?.type != 12">{{ userInfo.vipGrade != 0 ? '零售价' : '会员价'}} ¥{{userInfo.vipGrade != 0 ? attrSelect?.otPrice?.toFixed(2) : attrSelect?.price?.toFixed(2)}}</text>
			</view>
		</view>
		<view class="product-attr">
			<view class="attr-item" v-for="(item, index) in productAttr" :key="index">
				<view class="name">{{item?.attrName}}</view>
				<view class="attr-value">
					<text class="text" :class="choosedAttr?.[index] == child ? 'active' : ''"
					v-for="(child,ind) in item?.attrValuesArray" :key="ind" @click="attrChange(index, child)">{{child}}</text>
				</view>
			</view>
			<view class="number-box">
				<!-- <text class="name">数量</text> -->
				<view class="o-flex-r-s-c">
					<text class="name">数量</text>
					<view style="margin-left: 16rpx;" v-if="marketingType == '2' && buyLimitNum > 0">
						<text style="color: #F96525;font-size: 28rpx;">最多可购买{{buyLimitNum}}件</text>
					</view>
				</view>
				<view class="number">
					<wd-input-number v-model="productNumber" @change="numberChange" :min="attrSelect?.minNum != null ? attrSelect?.minNum : 1" :max="(marketingType == '2' && buyLimitNum > 0) ? buyLimitNum : 99" />
				</view>
			</view>
		</view>
		<view class="sure-box" v-if="showBottom">
			<view class="sure" @click="handleSure" v-if="type == 1">立即购买</view>
			<view class="sure cart" @click="handleAddCart" v-if="type == 2">加入购物车</view>
			<view class="sure" @click="handleSure" v-if="type == 3">确定</view>
		</view>
	</view>
</template>

<script setup>
	import { computed, onMounted, ref } from 'vue'
	import { addCart } from '@/api/product';
	import { storeToRefs } from 'pinia'
	import useStoreFun from '@/stores/index.js';
	const { useUserStore } = useStoreFun()
	const { userInfo } = storeToRefs(useUserStore)
	
	const choosedAttr = ref([]);
	const attrSelect = ref(null);
	const productNumber = ref(1);
	const props = defineProps({
		productValue: {
			default: []
		},
		productSelect: {
			default: {}
		},
		productAttr: {
			default: []
		},
		attrNumber: {
			default: 1
		},
		type: {
			default: 1
		},
		productType: {
			default: 1
		},
		showBottom: {
			default: true
		},
		marketingType: {
			default: '0',
		},
		groupBuyActivityResponse: {
			default: null,
		}
	})
	const emit = defineEmits(['changeAttr', 'close'])
	let buyLimitNum = computed(() => {
		if(props.groupBuyActivityResponse != null && attrSelect.value != null){
			let buyLimitCount = props.groupBuyActivityResponse?.buyLimitCount;
			let groupStock =  attrSelect.value?.groupStock;
			let stock =  attrSelect.value?.stock;
			let oncQuota = props.groupBuyActivityResponse?.oncQuota;
			let allQuota = props.groupBuyActivityResponse?.allQuota;
			// 极端情况判断
			if(oncQuota==0&&allQuota!=0){
				oncQuota=allQuota
			}
			if(oncQuota==0&&allQuota==0){
				oncQuota=groupStock
				allQuota=groupStock
			}
			if(buyLimitCount==-1){
				buyLimitCount=groupStock
			}
			let min = Math.min(buyLimitCount, groupStock, oncQuota, stock);
			if(min < props.attrNumber){
				productNumber.value = min;
				emit("changeAttr", attrSelect.value, productNumber.value);
			}
			return min;
		}
	})
	function getAttr(){
		props.productAttr.forEach(item => {
			item.attrValuesArray = item?.attrValues.split(",");
		})
	}
	onMounted(() => {
		getAttr();
		attrSelect.value = props.productSelect;
		choosedAttr.value = props.productSelect?.sku.split(",");
		productNumber.value = props.attrNumber;
	})
	function handleClose() {
		emit("close");
	}
	
	function attrChange(index, value){
		let newAttr = [];
		choosedAttr.value?.forEach((item, ind) => {
			if(ind == index) {
				newAttr?.push(value)
			}else{
				newAttr?.push(item)
			}
		});
		choosedAttr.value = newAttr;
		attrSelect.value = props.productValue.find(item => item.sku == choosedAttr.value?.join(","))
		productNumber.value = attrSelect.value?.minNum != null ? (buyLimitNum.value < attrSelect.value?.minNum ? buyLimitNum.value : attrSelect.value?.minNum) : 1;
		if(props.showBottom == false){
			emit("changeAttr", attrSelect.value, productNumber.value);
		}
		// emit("changeAttr", attrSelect.value, productNumber.value);
	}
	function numberChange(e){
		productNumber.value = e.value;
		if(props.showBottom == false){
			emit("changeAttr", attrSelect.value, productNumber.value);
		}
	}
	// function handleSure() {
	// 	if(this.attrSelect?.stock == 0){
	// 		uni.showToast({
	// 			title: "库存不足，请选择其他产品",
	// 			icon: "none"
	// 		})
	// 		return;
	// 	}
	// 	this.$emit("changeAttr", this.attrSelect, this.productNumber);
	// 	if(this.type == 1){
			
	// 	}
	// }
	function handleAddCart() {
		if(attrSelect.value.stock == 0){
			uni.showToast({
				title: "库存不足，请选择其他产品",
				icon: "none"
			})
			return;
		}
		addCart({
			productId: attrSelect.value?.productId,
			productAttrUnique: attrSelect.value?.id,
			cartNum: productNumber.value,
		}).then(() => {
			emit("changeAttr", attrSelect.value, productNumber.value);
			uni.showToast({
				title: "加入购物车成功",
				icon: "none"
			})
			const pages = getCurrentPages();
			let currentRoute = pages[pages.length - 1].route;
			if(currentRoute.indexOf("pages/cart/cart") > -1 ) {
				uni.$emit("cartOperate", null);
			}
		})
	}
</script>

<style lang="scss" scoped>
	.specifications {
		background: #FFFFFF;
		padding: 24rpx;
		.product{
			display: flex;
			flex-direction: row;
			.img{
				width: 150rpx;
				height: 150rpx;
				border-radius: 10rpx;
				margin-right: 24rpx;
			}
			.price-close{
				flex: 1;
				.close{
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
				}
				.price-box{
					display: flex;
					flex-direction: row;
					.text{
						font-family: PingFang SC, PingFang SC;
						font-weight: bold;
						font-size: 28rpx;
						color: #FF6F16;
						margin-top: 32rpx;
					}
					.f36{
						font-size: 36rpx;
						font-weight: 700;
						margin-left: 8rpx;
						margin-top: 28rpx;
					}
					.f64{
						color: #FF6F16;
						font-size: 64rpx;
						font-weight: 700;
						margin-top: 0;
					}
				}
				.old-price{
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 28rpx;
					color: #999999;
					text-decoration-line: line-through;
				}
			}
		}
		.product-attr{
			margin-top: 20rpx;
			.name{
				margin-bottom: 20rpx;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 30rpx;
				color: #333333;
			}
			.attr-value{
				width: 100%;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				.text{
					background: #f7f7f7;
					border-radius: 10rpx;
					padding: 10rpx 30rpx;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 30rpx;
					color: #353535;
					margin: 0 20rpx 20rpx 0;
					border: 2rpx solid #f7f7f7;
					white-space: nowrap;
				}
				.text.active{
					background: #FFF5F3;
					color: #FF6F16;
					border: 2rpx solid #FF6F16;
				}
			}
			.number-box{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				padding: 10rpx 4rpx 0;
				.name{
					margin-top: 20rpx;
				}
				// .number{
				// 	border: 2rpx solid #CECECE;
				// 	border-radius: 20rpx;
				// }
			}
		}
		.sure-box{
			width: 100%;
			margin-top: 50rpx;
			.sure{
				// display: block;
				width: 100%;
				height: 88rpx;
				
				background: linear-gradient( to left, #FF4700, #FF9800);
				border-radius: 80rpx;
				text-align: center;
				line-height: 88rpx;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 30rpx;
				color: #FFFFFF;
			}
			.cart {
				// background: #FF4700;
				background: #FF9800;
			}
		}
	}
</style>